import React from "react";
import Register from "./Component";

const Container = () => {
  return <Register />;
};

export default Container;
